import { useCallback, useState } from 'react'

/** State of a flat form object with a setter for one field */
export const useObject = <T extends object>(defaultValue: T) => {
  const [value, setValue] = useState<T>(defaultValue)
  const setField = useCallback(<K extends keyof T>(name: K, newValue: T[K]) => {
    setValue((current) => ({ ...current, [name]: newValue }))
  }, [])
  return [value, setField, setValue] as const
}
